import Head from '@conekta/cronos/declarative/Head';
import { ReactNode } from 'react';

type HeadUniversalProps = {
  merchantName?: string;
  paymentReason?: string;
  children?: ReactNode;
};

export const HeadUniversal = ({ children }: HeadUniversalProps) => (
  <Head>
    <link rel="preconnect" href="https://fonts.googleapis.com"></link>
    <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin=""></link>
    <link
      href="https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap"
      rel="stylesheet"
    ></link>
    {children}
  </Head>
);
